import React from 'react';
import PropTypes from 'prop-types';
import withConfig from '@/config/withConfig';
import SpotDetailsDirectionsMap from './directions-map';
import SpotDetailsPanelMap from './mobile-map-preview';
import {parseDistance} from 'utils/travel-distance';

export const FacilityLocation = ({
    isMobile,
    facility,
    walkingMeters,
    linearMeters,
}) => {
    const {
        latitude,
        longitude,
        airport: {
            details: {
                latitude: destinationLatitude,
                longitude: destinationLongitude,
            },
        },
        addresses,
    } = facility;

    const distance = parseDistance({
        linearMeters,
        walkingMeters,
        format: 'long',
    });

    return (
        <div className="FacilityLocation">
            <h4 className="subtitle">Facility Location</h4>
            {isMobile ? (
                <SpotDetailsPanelMap
                    spotLatitude={latitude}
                    spotLongitude={longitude}
                    destinationLatitude={destinationLatitude}
                    destinationLongitude={destinationLongitude}
                    linearMeters={linearMeters}
                    walkingMeters={walkingMeters}
                    isDriving
                    isDraggable
                />
            ) : (
                <SpotDetailsDirectionsMap
                    spotLatitude={latitude}
                    spotLongitude={longitude}
                    destinationLatitude={destinationLatitude}
                    destinationLongitude={destinationLongitude}
                    linearMeters={linearMeters}
                    walkingMeters={walkingMeters}
                    isDriving
                    isDraggable
                />
            )}
            <div className="FacilityLocation-address-distance">
                <span className="address">{addresses[0].street_address}</span>
                <span className="distance">Driving Distance: {distance}</span>
            </div>
        </div>
    );
};

FacilityLocation.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    facility: PropTypes.object.isRequired,
    walkingMeters: PropTypes.number,
    linearMeters: PropTypes.number,
};

export default withConfig(['isMobile'])(FacilityLocation);
